/**
 * IntroBlock
 */
import clsx from 'clsx';
import React from 'react';
/** An intro block with background. */
var IntroBlock = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { "data-cid": "IntroBlock", className: clsx('bg-introBlock-bg-color', 'text-introBlock-text-color', 'pt-14 pb-16 bg-hexagon bg-no-repeat intro-block') }, children));
};
export default IntroBlock;
